import { PRICE_SOURCE } from "../indicatorTypes";
import { priceReader } from "./priceSources";
import { smaAt } from "./movingAverages";

/**
 * Awesome Oscillator as TV: the short SMA of the median price (hl2) minus
 * the long one (Awesome and Accelerator Oscillator).
 *
 * @param {object} params
 * @param {object[]} params.bars
 * @param {number} params.shortPeriod
 * @param {number} params.longPeriod
 * @param {number[]} params.target
 * @param {number} params.fromIndex
 */
export const fillAwesomeOscillator = ({ bars, shortPeriod, longPeriod, target, fromIndex }) => {
  const read = priceReader(bars, PRICE_SOURCE.HL2);

  for (let index = fromIndex; index < bars.length; index += 1) {
    target[index] = smaAt(read, index, shortPeriod) - smaAt(read, index, longPeriod);
  }
};
